import { bubEvents } from 'shared/events/bub_events';

$(document).ready(() => {
  const menuOpenToggle = $('.mobile-burger-menu-icon');
  const menuCloseToggle = $('.burger-menu-cancel');
  const menu = $('.burger-menu-overlay-wrapper');
  let menuOpen = false;

  if (menu) {
    const closeMenu = () => {
      menu.attr('aria-hidden', true);
      menuOpen = false;
      menu.removeClass('active');
      $('body').css('overflow', '');
    };

    const openMenu = () => {
      menuOpen = true;
      menu.attr('aria-hidden', false);
      menu.addClass('active');
      $('body').css('overflow', 'hidden');
    };

    $(menuOpenToggle).on('click touch', () => {
      if (!menuOpen) {
        openMenu();

        bubEvents.track('Burger menu', 'Clicked icon', {
          label: 'Open menu',
        });
      }
    });

    $(menuCloseToggle).on('click touch', () => {
      if (menuOpen) {
        closeMenu();

        bubEvents.track('Burger menu', 'Clicked icon', {
          label: 'Close menu',
        });
      }
    });
  }
});
